// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__hTGhy","description":"PatientConsentPreview_description__2n1Y-"};